import { createContext, useContext } from 'react';

import { DEFAULT_PANEL_WIDTH, DocsPanelState } from './utils';

export interface DocsPanelApi {
  state: DocsPanelState;
  /** False on small screens, where a "Back to guide" chip is shown instead. */
  panelFits: boolean;
  /**
   * Docks a docs page beside the app and opens an app screen: `to`, else
   * the last app screen. Used by "Follow along" and by app links in the docs.
   */
  followAlong: (path: string, anchor?: string, to?: string) => void;
  /** Shows another docs page or section inside the panel. */
  openDocument: (path: string, anchor?: string) => void;
  /** Remembers the section being read. */
  setAnchor: (anchor?: string) => void;
  setWidth: (width: number) => void;
  /** Back to the full docs page, at the section being read. */
  expand: () => void;
  /** Ends following along; the panel stays closed until chosen again. */
  close: () => void;
}

const noop = () => {};

/** Outside the app (tests, sign-in) the panel does nothing. */
export const DocsPanelContext = createContext<DocsPanelApi>({
  state: { open: false, width: DEFAULT_PANEL_WIDTH },
  panelFits: false,
  followAlong: noop,
  openDocument: noop,
  setAnchor: noop,
  setWidth: noop,
  expand: noop,
  close: noop,
});

export const useDocsPanel = () => useContext(DocsPanelContext);
